export { PlusSmall as default } from './PlusSmall';
